<template>
    <el-container>
        <el-header>
          <div class="logodiv" style="height: 95px"><img alt="" src="static/relixue.jpg" width="100%"></div> <div class="regdiv"><span class="logout" @click="onLogout"><i class="el-icon-unlock"></i> 注销[实验老师]</span></div>
        </el-header>
        <el-main>
          <div class="cardrow">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="1"><router-link to="/relixue/index" style="text-decoration: none;">实验首页</router-link></el-menu-item>
              <el-menu-item index="2"><router-link to="/relixue/hall" style="text-decoration: none;">仿真实验</router-link></el-menu-item>
              <el-menu-item index="3"><router-link to="/relixue/upgrade" style="text-decoration: none;">下载升级</router-link></el-menu-item>
              <el-menu-item index="4">教学情况</el-menu-item>
              <el-menu-item index="5"><router-link to="/relixue/person" style="text-decoration: none;">用户中心</router-link></el-menu-item>
            </el-menu>
          </div>
          <div><img alt="" src="static/xlabbanner.jpg"></div>
          <div class="cardrow" style="text-align: left;">
            <span><el-tag effect="dark">实验统计</el-tag></span>
            <el-divider content-position="right">STATISTICAL DASHBOARD</el-divider>
              <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                  label="日期"
                  width="120">
                  <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span style="margin-left: 10px">{{ scope.row.date }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="姓名"
                  >
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                      <!-- <p>姓名: {{ scope.row.name }}</p> -->
                      <p>实验完成率: {{ scope.row.address }}</p>
                      <div slot="reference" class="name-wrapper">
                        <el-tag size="medium">{{ scope.row.name }}</el-tag>
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column label="实验记录" width="180">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row)">查看</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>
        </el-main>
        <el-footer>
          <el-divider></el-divider>
          系统集成与技术支持：湖南湘交高创信息技术有限公司 
          <el-rate
            v-model="rate"
            disabled
            show-score
            text-color="#ff9900"
            score-template="{value}">
          </el-rate>
        </el-footer>
    </el-container>
</template>


<script>
export default {
  data () {
    return {
      activeIndex: '4',
      currentDate: new Date(),
      rate: 3.9,
      tableData: [{
          date: '2021-05-02',
          name: '工程热力学B[063107B]： 能动本1801班-陈泊宏 虚拟仿真实验标准模块一《测量喷管流量》 课程设计',
          address: '登录29人，完成实验29人，上传实验报告27份'
        }, {
          date: '2021-05-04',
          name: '工程热力学B[063107B]： 能动本1802班-陈泊宏 虚拟仿真实验标准模块二《测量喷管轴向压力》 课程实践',
          address: '登录27人，完成实验26人，上传实验报告26份'
        }, {
          date: '2021-09-13',
          name: '工程热力学B[063107B]： 能动本1802班-陈泊宏 虚拟仿真实验标准模块二《测量喷管轴向压力》 课程实践',
          address: '登录30人，完成实验30人，上传实验报告24份'
        }, {
          date: '2021-09-26',
          name: '工程热力学B[063107B]： 能动本1801班-陈泊宏 虚拟仿真实验标准模块一《测量喷管轴向压力》 课程实践',
          address: '登录29人，完成实验28人，上传实验报告28份'
        }]
    }
  },
  beforeMount:function(){
    if (!sessionStorage.getItem('user')){
      this.$router.push({path: "/relixue/login"});
    }
  },
  mounted:function(){
      
  },
  methods: {
    onLogout() {
      this.$confirm('注销将清空实验操作空间, 操作结果是否已上传?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sessionStorage.removeItem("checked");
          this.$router.push({path: "/"});
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      
    },
    handleSelect() {

    },
    handleClick(e) {
      if (e === 0 || e === 2 || e === 3){
        this.$message.error('临时空间不足');
      }else{
        this.$message({
          message: '该步骤无下载项',
          type: 'success'
        });
      }
    },
    handleEdit(index, row) {
      this.$alert('您没有该实验的查看权限', '操作失败', {
        confirmButtonText: '确定',
        callback: action => {

        }
      });
    },
    handleDelete(index, row) {
      this.$alert('您没有该实验数据的删除权限', '操作失败', {
        confirmButtonText: '确定',
        callback: action => {

        }
      });
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-header {
    /* background-color: #B3C0D1; */
    color: #333;
    text-align: center;
    line-height: 95px;
    height: 95px !important; 
  }

  .el-footer {
    text-align: center;
    line-height: 35px;
  }
  
  .el-main {
    /* background-color: #0068B7; */
    /* color: #333; */
    text-align: center;
    /* line-height: 160px; */
    width: 100%;
    /* height: 50vh; */
    padding: 0;
    overflow: hidden;
  }

  .logodiv {
    float: left;
    margin-left: 10%;
  }

  .regdiv {
    float: right;
    margin-right: 10%;
  }

  .logout {
    color: #0068B7;
  }

  .logout:hover {
    cursor: pointer;
  }

  .cardrow {
    width: 60%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReLiXue/LabTeach.vue